import { Controller } from "@hotwired/stimulus"

// Add-to-cart control on product cards. Shows a plus button for a size that isn't in the cart
// and a stepper for one that is, switching between them when the size dropdown changes — the
// quantity for every size is handed to us by the server, so that needs no request.
//
// Each button sets an exact target quantity on the form before it submits (a click handler on
// the button runs before the form submits), so the server never has to guess a delta.
export default class extends Controller {
  static targets = ["weight", "quantityField", "addButton", "stepper", "count", "incrementButton"]
  static values = { quantities: Object, available: Number }

  connect() {
    this.render()
  }

  weightChanged() {
    this.render()
  }

  add() {
    this.quantityFieldTarget.value = 1
  }

  increment() {
    this.quantityFieldTarget.value = Math.min(this.currentQuantity + 1, this.availableValue)
  }

  // Zero is a removal — the server deletes the line.
  decrement() {
    this.quantityFieldTarget.value = Math.max(this.currentQuantity - 1, 0)
  }

  render() {
    const quantity = this.currentQuantity

    this.stepperTarget.classList.toggle("hidden", quantity <= 0)
    this.stepperTarget.classList.toggle("flex", quantity > 0)
    this.addButtonTarget.classList.toggle("hidden", quantity > 0)

    if (quantity <= 0) return

    this.countTarget.textContent = quantity

    // Nothing left in stock to add, so don't offer a plus that would only fail.
    if (this.hasIncrementButtonTarget) {
      const atStockLimit = quantity >= this.availableValue
      this.incrementButtonTarget.disabled = atStockLimit
      this.incrementButtonTarget.classList.toggle("opacity-40", atStockLimit)
      this.incrementButtonTarget.classList.toggle("cursor-not-allowed", atStockLimit)
    }
  }

  // -- helpers --

  // Piece-sold products have no size dropdown; their cart line is keyed by 0 grams.
  get selectedWeight() {
    return this.hasWeightTarget ? this.weightTarget.value : "0"
  }

  get currentQuantity() {
    return Number(this.quantitiesValue[String(this.selectedWeight)] || 0)
  }
}
